import type { PartialStoreState } from '../typings'

export const selectDeviceEvents = (state: PartialStoreState) =>
  state.domain.publicData.domain.gps.wwgps.eventInfos
